import styles from "./EmptyState.module.scss";
import Illustration from "./Illustration.svg?react";
import Background from "./Background.svg?react";
import Button from "../Button/Button";
import Badge from "../Badge/Badge";
import classNames from "classnames";

type EmptyStateProps = {
  icon: React.ReactNode;
  title?: string | null;
  buttonText?: string;
  buttonIcon?: React.ReactNode;
  buttonOnClick?: () => void;
  children?: React.ReactNode;
  hideBackground?: boolean;
  className?: string;
};

function EmptyState({
  icon,
  title,
  buttonText,
  buttonIcon,
  buttonOnClick,
  children,
  hideBackground,
  className,
}: EmptyStateProps) {
  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.header}>
        <div className={styles.illustrationContainer}>
          <Illustration />
          <span className={styles.icon}>{icon}</span>
        </div>
        <h2 className={styles.heading}>
          {title ? (
            <span>{title}</span>
          ) : (
            <Badge
              variant="pill"
              color="default"
              size="small"
              showDot={false}
              loading
            />
          )}
        </h2>
        {!hideBackground && <Background className={styles.background} />}
      </div>
      {buttonText && buttonOnClick && (
        <Button
          className={styles.button}
          leftIcon={buttonIcon}
          variant="primary"
          size="small"
          onClick={buttonOnClick}
        >
          {buttonText}
        </Button>
      )}
      {children && <div className={styles.children}>{children}</div>}
    </div>
  );
}

export default EmptyState;
